// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Compromissos_FinalizaCompromissoPorIdResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /compromissos/finaliza_compromisso_por_id/{id}
 *
 * Finalizes (checks out) an appointment and propagates status to its parent orcamento.
 * Returns the status-summary message produced by Orcamentos_model::atualiza_status_orcamento_apos_checkin().
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Compromissos_FinalizaCompromissoPorIdResponseDados {
message?: string
}

export type Compromissos_FinalizaCompromissoPorIdResponse = ApiResponse<Compromissos_FinalizaCompromissoPorIdResponseDados>;

registerResponseContract('Compromissos_FinalizaCompromissoPorIdResponse', {
  message: { type: 'string',  required: false },
})
